/**
 * Created by anatoly on 18.05.2025
 */

const UnitAcceptorAlgorithm = {
    priority: 0,

    listAcceptors: (targetUnit) => Map2d.currentMap.listAvailableUnits()
        .filter((unit) => unit.findAcceptorComponent(targetUnit))
        .filter(Boolean),

    findAcceptor: (unit, options) => {
        let target = Map2d.currentMap.getUnit(options.x, options.y);
        if (target) {
            if (target.head) {
                target = target.head;
            }

            const component = target.findAcceptorComponent(unit);

            if (component) {
                return component;
            }

            if (options.onDragEnd && target.findAcceptorComponent(unit, { skipBuild: true })) {
                cleverapps.centerHint.createTextHint(Messages.get("cantCollectBuilding", { target: Messages.get(`Units.${target.code}.stage${target.stage + 1}.name`) }));
            }
        }
    }
};
Draggable.registerAlgorithm(UnitAcceptorAlgorithm);